module.exports = __webpack_public_path__ + "img/car-red.da1553d9.svg";